
// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import useHistoricsStore from '@/app/store/modules/historics';
import actionsHistorics from '../../api/actionsHistorics';
// Components
import DataTable from '../../../../../common-utils/components/renders/dataTable/DataTable';
// Common
import { columnsPosTerminalsHistorics, columnsPosTerminalsHistoricsId } from './columnDef/columnsPosTerminalsHistorics';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import Permissions from '@/app/permissions/Permissions';
import HISTORICS from '../../api/apiUrls';
import { columnsHistorics } from './columnDef/columnsHistorics';
import HISTORICS_ACTION_TYPE from '../../enums/HistoricsActionType';
import getHistoricsExportDefaultQuery from '../../utils/getHistoricsExportDefaultQuery';

/**
 * @param {Object} props - Props object
 * @param {Object} props.customQuery - Custom query object
 * @param {Object} props.filtersEventName - Filters event name
 * @returns {JSX} PosTerminalsHistoricsTable
*/
function PosTerminalsHistoricsTable({ customQuery, filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const {
        refetchPosTerminalsHistorics: refetchFromStore,
        storeRefetchPosTerminalsHistorics,
        queryPosTerminalsHistorics: queryStored,
        storeQueryPosTerminalsHistorics: storeQuery } = useHistoricsStore();

    // State
    const initialQuery = getInitialQuery(customQuery);
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));

    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsHistorics.getPosTerminalsHistorics({ query: query }, false);

    // Saves custom query in store
    useEffect(() => {
        if (customQuery.filters && customQuery.filters.length > 0) {
            storeQuery(initialQuery);
        }
    }, [customQuery]);

    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchPosTerminalsHistorics(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    // Constants
    const exportDefaultQuery = getHistoricsExportDefaultQuery(data, query);

    const allColumns = columnsHistorics({
        query,
        setQuery,
        queryStored,
        storeQuery,
        setLaunchRefetch,
        customColumns: columnsPosTerminalsHistorics,
        actions: HISTORICS_ACTION_TYPE.POS_TERMINALS,
        filtersEventName
    });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsPosTerminalsHistoricsId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}
            hasPartialResults={true}

            exportProps={{
                permissions: [Permissions.EXPORT_HISTORY.name],
                api: HISTORICS.POS_TERMINALS.EXPORT,
                query: exportDefaultQuery
            }}
        />
    );
}

PosTerminalsHistoricsTable.propTypes = {
    customQuery: PropTypes.object,
    filtersEventName: PropTypes.string
};

export default PosTerminalsHistoricsTable;